var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOliverIconError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 95,
    viewBox: "0 0 131 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.8026 6.25H52.5919V30.4607H76.8026V6.25Z",
    fill: "#B0BEC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0299 6.25C38.494 7.17101 28.4917 17.5048 27.6002 30.4607H51.0299V6.25Z",
    fill: "#B0BEC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0299 32.0195H27.6002V56.2302H51.0299V32.0195Z",
    fill: "#B0BEC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.575 32.0195H78.3646V56.2302H102.575V32.0195Z",
    fill: "#B0BEC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3646 81.2227C91.3228 80.3355 101.654 70.3332 102.575 57.793H78.3646V81.2227Z",
    fill: "#B0BEC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8026 57.793H52.5919V81.2227H76.8026V57.793Z",
    fill: "#B0BEC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0299 57.793H27.6002C28.4874 70.3374 38.4854 80.3355 51.0299 81.2227V57.793Z",
    fill: "#B0BEC9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.6591 74.1077C104.725 84.5037 118.675 87.999 130.341 82.2931L118.626 62.0024L97.6591 74.1077Z",
    fill: "#D8DFE4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOliverIconError);
export default __webpack_public_path__ + "static/media/OliverIconError.a16253d2c65a7010cfc4d661e46f9ade.svg";
export { ForwardRef as ReactComponent };